import { BenefitType, Subsidy } from "#/lib/carrot-api/types/Subsidy"

export const isCreditMember = (subsidies: Subsidy[]): boolean =>
  subsidies.some((subsidy) => subsidy.benefitType === BenefitType.CREDIT)

// Extra filters apply to credit members only.
export const getVisibleSubsidies = (subsidies: Subsidy[]): Subsidy[] => {
  const creditMember = isCreditMember(subsidies)
  return subsidies.filter(
    (subsidy) =>
      !!subsidy.reimbursementCategoryNameMessageKey &&
      (subsidy.reimbursementCategoryNameMessageKey !== "OTHER" || subsidy.lifetimeAmounts.max !== 0) &&
      (!creditMember ||
        (subsidy.isReimbursable !== false &&
          (subsidy.benefitType !== BenefitType.CREDIT ||
            (subsidy.creditLifetimeMax != null && subsidy.remainingCredits != null))))
  )
}

// CREDIT and FUND plans can share a category; credits first.
export const groupByCategory = (subsidies: Subsidy[]): Subsidy[][] => {
  const byCategory = new Map<string, Subsidy[]>()
  subsidies.forEach((subsidy) => {
    const key = subsidy.reimbursementCategoryNameMessageKey
    byCategory.set(key, [...(byCategory.get(key) ?? []), subsidy])
  })
  const isCredit = (subsidy: Subsidy): number => Number(subsidy.benefitType === BenefitType.CREDIT)
  return [...byCategory.values()].map((group) => group.sort((a, b) => isCredit(b) - isCredit(a)))
}

export const getCategoryGroups = (subsidies: Subsidy[]): Subsidy[][] => groupByCategory(getVisibleSubsidies(subsidies))

export const countCategories = (subsidies: Subsidy[]): number =>
  isCreditMember(subsidies) ? getCategoryGroups(subsidies).length : subsidies.length
